import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import RosterTable from "../../components/RosterTabel/rosterTable";
import UserTable from "../../components/UserTabel/userTable";
import classes from "./SearchResult.module.css";
import { searchTrainee } from "../../services/userServices";
import BackdropComponent from "../../components/Spinner/Spinner";

export const SearchResult = () => {
  const { searchType, searchValue } = useParams();
  const [loading, setLoader] = useState([false]);
  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoader(true);
      }

      try {
        const userDetails = await searchTrainee(searchType, searchValue);

        if (cancelled) return;

        if (userDetails.status === true) {
          let TraineeDetails = [];

          if (userDetails.data.length > 0) {
            TraineeDetails.push(userDetails.data[0].traineeDetail);

            if (!cancelled) {
              setSearchData(userDetails.data);
            }
          } else {
            if (!cancelled) {
              setSearchData([]);
            }
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to search trainee:", error);
        }
      } finally {
        if (!cancelled) {
          setLoader(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [searchType, searchValue]);

  return (
    <div className={classes.pageContainer}>
      {loading ? <BackdropComponent /> : null}
      {searchData.length === 0 && (
        <p className={classes.noData}>No Data Available</p>
      )}
      {searchData.length > 0 &&
        searchData.map((data, i) => (
          <div key={i}>
            <UserTable userDetails={data.traineeDetail} />
            <RosterTable roster={data.rosterDetails} />
          </div>
        ))}
    </div>
  );
};
